import { useIntl } from 'react-intl';

import { Form, FormItemProps, Typography } from 'antd';
import StatusTag from '@/components/_common/StatusTag';
import { Status, StatusColor } from '@/utils/enum/statusEnum';
import { Group } from '@/components/_common';

const SituationFormField = ({ initialValue }: FormItemProps) => {
  const intl = useIntl();
  const { Title } = Typography;

  return (
    <Form.Item noStyle shouldUpdate>
      {() => (
        <Group gap={10}>
          <Title level={4} style={{ margin: 0 }}>
            {intl.formatMessage({ id: 'directSale.situation' })}
          </Title>

          <StatusTag
            size="lg"
            style={{ fontSize: 20 }}
            label={intl.formatMessage({
              id: `directSale.${initialValue || Status.open}`,
            })}
            color={
              StatusColor[initialValue ? (initialValue as Status) : Status.open]
            }
          />
        </Group>
      )}
    </Form.Item>
  );
};

export default SituationFormField;
